import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form } from "../../Components/ui/form/form";

import { Input } from "../../Components/ui/form";
import { useMutate } from "../../Hooks/use-mutate";
import { Card } from "../../Components/ui/card";

type TrailerAssetData = {
  unit: string;
  license_plate: string;
};

type CreateTrailerAssetResponse = {
  id: number;
  unit: string;
  license_plate: string;
};

export const CreateTrailerAssetForm = ({ cancel }: { cancel: () => void }) => {
  const [unit, setUnit] = useState("");
  const [licensePlate, setLicensePlate] = useState("");
  const navigate = useNavigate();

  const submitResult = useMutate<TrailerAssetData, CreateTrailerAssetResponse>(
    "/assets/trailer-assets/",
    "POST",
  );
  const handleSubmit = async (e: React.SubmitEvent) => {
    e.preventDefault();
    const data: TrailerAssetData = {
      unit,
      license_plate: licensePlate,
    };
    const response = await submitResult.mutate(data);
    if (response?.status === 201) {
      navigate("/trailer-assets/" + response.data?.id);
    }
  };

  return (
    <div className="page-mask page-mask-animation">
      <Card title="Create Trailer Asset" titleKey="createTrailer" size="sm">
        <Form
          onSubmit={handleSubmit}
          isLoading={submitResult.isLoading}
          cancel={cancel}
        >
          <Input
            label="unit"
            value={unit}
            onChange={(e) => setUnit(e.target.value)}
          />
          <Input
            label="licensePlate"
            value={licensePlate}
            onChange={(e) => setLicensePlate(e.target.value)}
          />
        </Form>
      </Card>
    </div>
  );
};
